namespace Matrix {
    export interface ScriptUserDefinition {
        Username?: string;
        DisplayName?: string;
        IsAdmin?: boolean;
        IsDevelopment?: boolean;
        CanAddDeleteUsers?: boolean;
        Permissions?: { [key: string]: boolean };
        UsePreviewFeatures?: boolean;
    }
}
